import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  /** @type {HTMLDivElement} */
  invitation_sites_list;

  /** @type {HTMLSelectElement} */
  invitation_role_select;

  /** @type {HTMLSelectElement} */
  invitation_site_select;

  /**@type {HTMLInputElement} */
  site_field;

  /**@type {HTMLInputElement} */
  sponsor_field;

  /**@type {HTMLInputElement} */
  invitation_workspaces_list;
  
  /**@type {HTMLDivElement} */
  invitation_protocols_list

  /**@type {HTMLDivElement} */
  invitation_labs_list

  static values = {
    workspaces: Array,
  };

  static targets = ["list"];

  connect() {
    this.element.addEventListener("submit", this.handleSubmit.bind(this));
    this.invitation_sites_list = document.getElementById(
      "invitation_sites_list"
    );
    this.invitation_role_select = document.getElementById(
      "invitation_role_select"
    );
    this.invitation_site_select = document.getElementById(
      "invitation_site_select"
    );
    this.invitation_workspaces_list = document.getElementById(
      "invitation_workspaces_list"
    );
    this.invitation_protocols_list = document.getElementById(
      "invitation_protocols_list"
    );
    this.invitation_labs_list = document.getElementById(
      "invitation_labs_list"
    );
    this.site_field = document.getElementById("site_id");
    this.sponsor_field = document.getElementById("sponsor_id");

    this.invitation_sites_list.hidden = true;
    this.invitation_role_select.addEventListener(
      "change",
      this.handleRoleSelectChange.bind(this)
    );

    this.invitation_site_select.addEventListener(
      "change",
      this.handleSiteSelectChange.bind(this)
    );

    this.handleRoleSelectChange()
  }

  handleRoleSelectChange() {
    this.invitation_sites_list.hidden = !this.isSiteStaffSelected;

    if (this.isSiteStaffSelected) {
      this.invitation_workspaces_list.style.display = "block";
      this.invitation_protocols_list.style.display = "none";
      this.invitation_labs_list.style.display = "none";
      this.updateWorkspaceList();
    }else{
      this.invitation_workspaces_list.style.display = 'none';
    }
  }

  handleSiteSelectChange(){
    this.updateWorkspaceList()
  }

  handleSubmit() {
    if (this.isSiteStaffSelected) {
    // this.sponsor_field.value = "";
      this.site_field.value = this.selectedSite;
    } else {
      this.site_field.value = "";
    }
  }

  updateWorkspaceList() {
    this.listTarget.replaceChildren();
    this.workspacesValue
      .filter(({ site_id }) => site_id === this.selectedSite)
      .forEach(({ workspace_id, workspace_name }) => {
        const div = document.createElement("div");
        div.style.marginBottom = 0;
        div.classList.add("checkbox");
        const label = document.createElement("label");
        const input = document.createElement("input");
        input.type = "checkbox";
        input.id = `workspace-${workspace_id}`;
        input.value = workspace_id;
        input.name = "workspace_ids[]";

        label.appendChild(input);
        label.appendChild(document.createTextNode(` ${workspace_name}`));
        div.appendChild(label);
        this.listTarget.appendChild(div);
      });
  }

  get selectedRole() {
    return this.invitation_role_select.options[
      this.invitation_role_select.selectedIndex
    ].value;
  }

  get selectedSite() {
    return this.invitation_site_select.options[
      this.invitation_site_select.selectedIndex
    ].value;
  }

  get isSiteStaffSelected() {
    return this.selectedRole == "site_staff";
  }
}
